var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNetworkSymbol = function SvgNetworkSymbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.26087L2 7.26087C6.97 2.29087 15.03 2.29087 20 7.26087L22 5.26087C15.93 -0.809126 6.08 -0.809126 0 5.26087ZM8 13.2609L11 16.2609L14 13.2609C13.6064 12.8662 13.1388 12.5531 12.624 12.3395C12.1092 12.1259 11.5574 12.0159 11 12.0159C10.4426 12.0159 9.89075 12.1259 9.37596 12.3395C8.86117 12.5531 8.39359 12.8662 8 13.2609ZM4 9.26087L6 11.2609C7.32646 9.93551 9.12487 9.19102 11 9.19102C12.8751 9.19102 14.6735 9.93551 16 11.2609L18 9.26087C14.14 5.40087 7.87 5.40087 4 9.26087Z",
    fill: "#CECFD5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNetworkSymbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NetworkSymbol.7c45280c.svg";
export { ForwardRef as ReactComponent };